<script lang="ts">
import Icon from "@/Components/Generics/Icon.vue";
import { defineComponent } from "vue";

export default defineComponent({
    components: {
        Icon,
    },
    props: {
        extraTitle: {
            type: String,
            default: null,
        },
        logoSmall: {
            type: Boolean,
            default: false,
        },
    },
    emits: [],
    data: () => ({}),
    computed: {},
    methods: {},
});
</script>

<template>
    <a class="home flex flex--valign-c flex--gap-20" :href="route('main')">
        <span class="job-fox-logo" :class="{ small: logoSmall }">
            <Icon :identifier="'djf_update_logo'" />
        </span>
        <span class="text text--primary-gradient text--bold text--size-32 text--less-gap">
            {{ $trans("navigation.nav_title") }}
            <template v-if="extraTitle">- {{ extraTitle }}</template>
        </span>
    </a>
</template>

<style lang="scss" scoped>
.job-fox-logo {
    display: block;
    transition: width 0.2s ease-in-out;
    width: rem(100);
    // filter: drop-shadow(0 rem(1) rem(0) #0008);
    &.small {
        width: rem(65);
    }
}

@include media-breakpoint-down(lg) {
    .job-fox-logo {
        width: rem(90);

        &.small {
            width: rem(60);
        }
    }
}
@include media-breakpoint-down(md) {
    .job-fox-logo {
        width: rem(80);

        &.small {
            width: rem(50);
        }
    }
}
@include media-breakpoint-down(sm) {
    .job-fox-logo {
        width: rem(70);

        &.small {
            width: rem(40);
        }
    }
}
</style>
